/**
 * interact.js 1.10.26
 *
 * Copyright (c) 2012-present Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/main/LICENSE
 */

var edgeTarget = () => {};
export { edgeTarget as default };
//# sourceMappingURL=edgeTarget.js.map
